import { Show } from 'solid-js';
import { FiToggleLeft, FiToggleRight } from 'solid-icons/fi';

export interface IconToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  title?: string;
  /** When true (default), show On/Off status text beside the label. */
  showStatus?: boolean;
}

/** On/off toggle using FiToggleLeft / FiToggleRight (same pattern as AdminStreaming). */
export default function IconToggle(props: IconToggleProps) {
  const showStatus = () => props.showStatus !== false;

  return (
    <div class="icon-toggle">
      <Show when={props.label}>
        <span class="icon-toggle__label">{props.label}</span>
      </Show>
      <Show when={showStatus()}>
        <span class="icon-toggle__status">{props.checked ? 'On' : 'Off'}</span>
      </Show>
      <button
        type="button"
        class="icon-toggle__btn"
        disabled={props.disabled}
        onClick={() => props.onChange(!props.checked)}
        title={props.title}
        aria-pressed={props.checked}
        aria-label={props.label ? `${props.label} ${props.checked ? 'on' : 'off'}` : undefined}
      >
        <Show
          when={props.checked}
          fallback={<FiToggleLeft size={24} class="icon-toggle__icon icon-toggle__icon--off" />}
        >
          <FiToggleRight size={24} class="icon-toggle__icon icon-toggle__icon--on" />
        </Show>
      </button>
    </div>
  );
}
